import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {FeatureFlagService} from '@app/services/feature-flag.service';
import {Subject} from 'rxjs';
import {AccountFeaturesEnum} from '@app/interfaces/config/accountFeaturesEnum';
import {takeUntil} from 'rxjs/operators';

@Directive({
  selector: '[appIfCountryFeatureAvailable]',
  standalone: false
})
export class IfCountryFeatureAvailableDirective implements OnInit, OnDestroy {

  @Input('appIfCountryFeatureAvailable') public featureFlag: AccountFeaturesEnum | AccountFeaturesEnum[];

  private destroy$ = new Subject<void>();

  constructor(private viewContainerRef: ViewContainerRef,
              private featureFlagsService: FeatureFlagService,
              private templateRef: TemplateRef<any>) {
  }

  ngOnInit(): void {
    this.featureFlagsService.getCountryAvailableFeatures().pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.viewContainerRef.clear();
        if (this.isFeatureAvailableInCountry(result)) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      }, (error) => {
        this.viewContainerRef.clear();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.viewContainerRef.clear();
  }

  private isFeatureAvailableInCountry(result: { [p: string]: boolean }): boolean {
    if (!result || !this.featureFlag) {
      return false;
    }

    if (typeof this.featureFlag === 'string') {
      return result[this.featureFlag] ?? false;
    }

    if (Array.isArray(this.featureFlag)) {
      return this.featureFlag.every(flag => result[flag] ?? false);
    }

    return false;
  }
}
